export enum KindEnum {
  DEMO = 'Demo',
  REAL = 'Real'
}
